import React, { useEffect, useState } from 'react';
import { getTokenFromLocalStorage } from '../utils/helper';
import { Navigate, Outlet } from 'react-router-dom';
import { useGetCompaniesListQuery } from '../store/apis/companyApi';
import { link } from '../constants/appConstants';

const ProtectedRoutes = () => {
  const token = getTokenFromLocalStorage();
  const [skip, setSkip] = useState(true);
  useGetCompaniesListQuery(token, { skip });

  useEffect(() => {
    if (token) {
      setSkip(false);
    }
  }, [token]);

  return <>{token ? <Outlet /> : <Navigate to={link.default} />}</>;
};

export default ProtectedRoutes;
